import React, { FC, useMemo } from 'react';
import Modal from './common/Modal/Modal';

import { findChainBySymbol } from '../datas/chains';

interface ModalTransactionCompleteProps {
  isShow: boolean;
  chainSymbol: string | undefined;
  txHash: string | null | undefined;
  onRequestClose: () => void;
}

const ModalTransactionComplete: FC<ModalTransactionCompleteProps> = ({
  isShow,
  chainSymbol,
  txHash,
  onRequestClose,
}) => {
  const chain = useMemo(
    () => chainSymbol && findChainBySymbol(chainSymbol),
    [chainSymbol],
  );

  return (
    <Modal
      size="sm"
      isShow={isShow}
      onClose={onRequestClose}
      title="Transaction confirmation"
      explanation="Transaction completed."
      headerComponentExtended={
        txHash && (
          <>
            <h6>Tx Hash</h6>
            <a
              href={
                chain
                  ? chain.explorerUrl + chain.explorerTxPrefix + txHash
                  : `#` // TX값 인입 필요
              }
              target="_blank"
              className="wallet-name"
              rel="noreferrer"
            >
              <i data-icon="window" />
              {txHash}
            </a>
          </>
        )
      }
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalTransactionComplete;
